import { homeEquityLoanTypes } from "shared_critical/format_helper";

MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW = (function () {
  var props,
      $homeValue = $('input#home-value'),
      $loanAmount = $('input#loan-amount'),
      $mortgageBalance = $('input#mortgage-balance'),
      state = {},
      $propertyLocation = $('input#locationBox'),
      $creditScoreSelect = $('select.js-credit-score-selector'),
      $btnEditSearch = $('.js-sort .js-edit-start'),
      $findRate = $('.js-find-rates-button'),
      $searchFacet = $('.js-card-search-facet'),
      $pagination = $('#pagination');

  var init = function (propsRef) {
    props = propsRef;
  };

  var render = function () {
    $('.hel-rates-search .js-search-errors').hide();
    $propertyLocation.val(props.search.location).css("color", "black");
    $homeValue.val(MOVE.MORTGAGE.addDollarCommas(props.search.property_value));
    $loanAmount.val(MOVE.MORTGAGE.addDollarCommas(props.search.loan_amount));
    $mortgageBalance.val(MOVE.MORTGAGE.addDollarCommas(props.search.mortgage_balance))
    $creditScoreSelect.val(props.search.credit_score).trigger('change');
    $searchFacet.removeClass('edit-mode').addClass('hidden-xs').addClass('hidden-sm').addClass('hidden-md');
    $btnEditSearch.removeClass('hide').removeClass('active');
    $('#loan-type-display').val(loanTypesDisplay(props.search.loan_product));
    $('#current-mortgage-balance').val(MOVE.MORTGAGE.addDollarCommas(props.search.mortgage_balance));
    $('.rate-loan-type-display').show();
    $('.rate-current-mortgage-balance').show();
    $('.rate-home-value').hide();
    $('.rate-mortgage-balance').hide();
    $('.rate-credit-score').hide();
    renderLoanTypes(props.search.loan_product);

    bindLoanTypes();
  };

  var loanTypesDisplay = function(loanTypes) {
    if (!loanTypes.length) return;
    var result = [];
    var heloans = extractHeloans(loanTypes);

    if (checkAllLoanTypes(loanTypes)) {
      return '(All) Home Equity Loans';
    }
    if (loanTypes === 'HELOC') {
      return 'HELOC';
    }
    loanTypes = loanTypes.split(',');
    if (loanTypes.indexOf('HELOC') > -1) {
      result.push('HELOC');
    }
    //if multiple home equity loans selected, display 'Home Equity Loan(s)', else, also display years
    if (heloans.length > 1) {
      result.push('Home Equity Loan(s)');
    } else {
      var years = heloans[0].match(/\d/g).join('');
      var text = 'Home Equity Loan - ' + years + ' years';
      result.push(text);
    }
    return result.join(', ');
  }

  var extractHeloans = function(loanTypes) {
    loanTypes = loanTypes.split(',');
    var heloans = loanTypes.filter((each) => each.indexOf('HELOAN') > -1);

    return heloans;
  }

  var checkAllLoanTypes = function(loanTypes) {
    loanTypes = loanTypes.split(',');
    var allLoanTypes = homeEquityLoanTypes.slice(1).map((type) => type.value);

    for (var i = 0; i < allLoanTypes.length; i++) {
      if (loanTypes.indexOf(allLoanTypes[i]) < 0) {
        return false;
      }
    }
    return true;
  }

  var renderLoanTypes = function (selectedLoanTypes) {
    var path = 'templates/mortgage/home_equity_rate_table_loan_type_checkboxes';
    path = MOVE.Helper.isPhone() ? path + '_mobile': path;
    var context = $('#loan-filters');
    var content = JST[path]({
      loanTypesAvailable: homeEquityLoanTypes,
      loanTypesSelected: selectedLoanTypes,
    });
    context.html(content);
  }

  var bindLoanTypes = function() {
    $('.js-loan-filters input[type="checkbox"]').on('change', handleLoanTypeChange);
  }

  var handleLoanTypeChange = function (e) {
    e.preventDefault();
    var value = $(this).val();
    var fields = $('#loan-filters input').serializeArray();
    var selected = _.map(fields, function (field) {
      return field.value;
    });

    state.loan_product = computeLoanTypeValues(selected, value);
    renderLoanTypes(state.loan_product);
    bindLoanTypes();
  };

  var computeLoanTypeValues = function(values, newValue) {
    var allLoanTypeValues = homeEquityLoanTypes[0].value;
    if (newValue !== allLoanTypeValues) {
      values = _.reject(values, function(ltype) { return ltype === allLoanTypeValues; });
    }

    if (values.indexOf(allLoanTypeValues) > -1 || allHelocLoanTypesSelected(values)) {
      return _.map(homeEquityLoanTypes, function(loanType) {
        return loanType.value;
      });
    } else {
      return values;
    }
  };

  var bind = function (actions) {
    return MOVE.Helper.isPhone() ? bindMobile(actions) : bindDesktop(actions);
  };

  var bindMobile = function (actions) {
    $('.js-edit-search').on('click', showMobileSearch);
    $('.js-find-rates-button-cancel').on('click', cancelMobileSearch);

    bindSharedControls(actions);
  };

  var bindDesktop = function (actions) {
    $('.card-search-facet input, .js-card-search-facet .bootstrap-select, .js-edit-start')
    .on('click', function () {
      $('.js-search-errors').text('')

      if ($searchFacet.hasClass('edit-mode')) {
        return;
      }
      $searchFacet.addClass('edit-mode');
      enterEditMode();
      $('.hel-rates-search .card-search-facet').removeClass('hidden-xs').removeClass('hidden-sm').removeClass('hidden-md');
      $btnEditSearch.addClass('hide');
    });

    $('.js-edit-cancel').on('click', cancelHelocDesktopSearch);

    bindSharedControls(actions);
    $('.hel-rates-search').addClass('appear');
  };

  var bindSharedControls = function (actions) {
    $propertyLocation
      .on('keyup', function () {
        state.geo_valid = false;
        $propertyLocation.removeClass('input-search-error');
      })
      .on('change', function () {
        state.geo_valid = false;
        if ($(this).val() === '') {
          $propertyLocation.addClass('input-error');
          $propertyLocation.attr('placeholder', 'Please Enter a Location');
        } else {
          $.fn.autocomplete.newSearch({location: $(this).val()});
        }
      });

    $homeValue
      .on("keypress", MOVE.MORTGAGE.restrictNumbersOnly)
      .on('change', function () {
        var field = $(this),
          value = MOVE.MORTGAGE.removeDollarCommas(field) || 0,
          loanAmount = MOVE.MORTGAGE.removeDollarCommas($loanAmount);

          if (value <= loanAmount) {
            $('#loan-amount-error').removeClass('no-show');
          } else {
            $('#loan-amount-error').addClass('no-show');
          }
        field.val(MOVE.MORTGAGE.addDollarCommas(value));
        state.property_value = value;
        state.loan_amount = loanAmount;
      });

    $loanAmount
      .on("keypress", MOVE.MORTGAGE.restrictNumbersOnly)
      .on('change', function () {
        var currentHomeValue = MOVE.MORTGAGE.removeDollarCommas($homeValue);
        var field = $(this),
          value = MOVE.MORTGAGE.removeDollarCommas(field) || 0,
          max = currentHomeValue;

          if (value > max) {
            $('#loan-amount-error').removeClass('no-show');
          } else {
            $('#loan-amount-error').addClass('no-show');
          }
        field.val(MOVE.MORTGAGE.addDollarCommas(value));
        state.loan_amount = value;
      });

    $mortgageBalance
      .on("keypress", MOVE.MORTGAGE.restrictNumbersOnly)
      .on('change', function () {
        var field = $(this),
          value = MOVE.MORTGAGE.removeDollarCommas(field) || 0;

        state.mortgage_balance = value;
        field.val(MOVE.MORTGAGE.addDollarCommas(value));
      });

    $creditScoreSelect.on('change', handleCreditScoreChange);

    $findRate.on('click', function () {
      if (!state.loan_product.length) {
        MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW.actions
          .displayRatesSearchError('Please select one or more loan types.');
        return;
      }
      if (!$('#loan-amount-error').hasClass('no-show')) { return; }
      if (state.geo_valid == false) {
        mimicLocationGoButtonClick();
        setTimeout(function () {
          if (state.geo_valid == true) {
            search(actions);
          } else {
            if ($('.h5').html() !== 'Please include zip code for this location') {
              helocNoLocationFound();
            }
          }
        }, 1000);
      } else {
        search(actions);
        $('.js-autocomplete-dropdow').hide();
      }
    });
  };

  var helocLocationChanged = function (address, zip, city, state_code) {
    var addrs = address.split(',');
    if (addrs.length === 1){
      return;
    }
    state.zip = Array.isArray(zip) ? zip[0] : zip;
    if (state.zip === null || state.zip === undefined) {
      state.location = address
      helocNoZipCodeFound()
    } else {
      state.location = addrs.length === 2 && state.zip !== undefined ? state.zip +', '+ address : address;
      state.state = state_code;
      state.city = city;
      state.geo_valid = true;
      $propertyLocation.val(state.location);
      enableHelocSearchButton();
    }
  };

  var helocNoLocationFound = function () {
    $('.js-autocomplete-dropdow').slideDown("fast", function () {
      $(this).children('.js-no-found-results').html('<p class="h5 autocomplete-title font-normal">Please enter a valid location</p>');
      $(this).children('.js-no-found-results').removeClass('no-show');
    });
  };

  var helocNoZipCodeFound = function() {
    $propertyLocation.addClass('input-search-error');
    $('.found-search-results').addClass('no-show')
    $('.js-autocomplete-dropdow').slideDown("fast", function () {
      $(this).children('.js-no-found-results').html('<p class="h5 autocomplete-title font-normal">Please include zip code for this location</p>');
      $(this).children('.js-no-found-results').removeClass('no-show');
    });
  }

  var allLoanTypeValues = function() {
    return _.map(homeEquityLoanTypes, function(ltype) { return ltype.value; });
  };

  var allHelocLoanTypesSelected = function(values) {
    var allValues = allLoanTypeValues();
    return JSON.stringify(allValues) === JSON.stringify(values);
  };

  var handleCreditScoreChange = function () {
    var value = $(this).val();
    state.credit_score = value;
  };

  var cancel = function () {
    render();
  };

  var search = function (actions) {
    $btnEditSearch.removeClass('hide').removeClass('active');
    props.search = state;

    if (props.search.zip) {
      searchFromProps(actions);
    } else {
      mimicLocationGoButtonClick();
      setTimeout(function() { searchFromProps(actions) }, 1500);
    }

    enableHelocLoadingSpinner();
  };

  var searchFromProps = function(actions) {
    if (props.search.loan_product.length > 0) {
      $btnEditSearch.removeClass('hide').removeClass('active');
      $searchFacet.removeClass('edit-mode').addClass('hidden-xs').addClass('hidden-sm').addClass('hidden-md');
      $('.js-autocomplete-dropdow').hide();
      $('.js-search-errors').hide();
      actions.searchRates();
      render();
    } else {
      MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW.actions
        .displayRatesSearchError('Please select one or more loan types.');
    }
  };

  var enableHelocLoadingSpinner = function () {
    if (!MOVE.Helper.isPhone()) {
      return;
    }
    $findRate.hide('fast', function () {
      $('#rates-loading-spinner').show().css("display", "inline-block");
    });
  };

  var disableHelocLoadingSpinner = function () {
    if (!MOVE.Helper.isPhone()) {
      return;
    }
    $('#rates-loading-spinner').hide();
    $findRate.show();
  };

  var enterEditMode = function () {
    state = _.clone(props.search);
    $('.rate-loan-amount > label').html('Loan Amount');
    $loanAmount.val(MOVE.MORTGAGE.addDollarCommas(props.search.loan_amount));
    $('.rate-loan-type-display').hide();
    $('.rate-current-mortgage-balance').hide();
    $('.rate-home-value').show();
    $('.rate-mortgage-balance').show();
    $('.rate-credit-score').show();
  };

  var enableHelocSearchButton = function () {
    var label = MOVE.Helper.isPhone() ? 'Find Rates' : 'Update Rates';
    $findRate.attr('disabled', false).text(label);
  };

  var displayRatesSearchError = function (message) {
    $('.js-search-errors').text(message).show();
    setTimeout(disableHelocLoadingSpinner, 1000);
  };

  var showMobileSearch = function (e) {
    e.preventDefault();
    disableHelocLoadingSpinner();
    enterEditMode();
    $pagination.hide();
    $('.hel-rate-table-mobile.js-hel-rate-table-mobile').slideUp('fast', function () {
      $('.js-hel-rates-search-mobile').slideDown('fast', function () {
        $('.rate-loan-search-tabs.js-rate-loan-search-tabs').show();
        $('.hel-rates-provider-disclaimer').addClass('hide');
        $('html, body').animate({scrollTop: 0}, 600);
      });
    });
  };

  var cancelMobileSearch = function (e) {
    e.preventDefault();
    $propertyLocation.removeClass('input-search-error');
    cancel();
    disableHelocLoadingSpinner();
    $('.js-hel-rates-search-mobile').hide('fast', function () {
      $('.js-hel-rate-table-mobile').show('fast');
      $('.js-autocomplete-dropdow').hide();
      $('.js-search-errors').hide();
      $('#loan-amount-error').addClass('no-show');
      $pagination.show();
    });
  };

  var cancelHelocDesktopSearch = function () {
    // Hide dropdown if still open
    $propertyLocation.removeClass('input-search-error');
    $('.js-autocomplete-dropdow').hide();
    $('#loan-amount-error').addClass('no-show');
    cancel();
  };

  var mimicLocationGoButtonClick = function () {
    $('button.js-searchButton').click();
  };

  MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW = {
    init: init,
    render: render,
    bind: bind,
    actions: {
      helocLocationChanged: helocLocationChanged,
      helocNoLocationFound: helocNoLocationFound,
      displayRatesSearchError: displayRatesSearchError
    }
  };

  return MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/views/heloc_search_view.js